import React, { useEffect, useRef, useState } from 'react';
import { Autocomplete, TextField } from '@mui/material';

import useWizardReportDataContext from '../../../../../contexts/useWizardReportData.context';
import IReportAvailableColumn from '../../../../../../../../shared/contracts/IReportAvailableColumn';


/**
 * @author Pradeep R <pradeep.rajendran@rldatix.com>
 * @createdOn Jan/05/2025
 */
export default function WizardPivotParentColumnComponent({ }: {}) {

    const { availableColumns: options, pivotData, setPivotData } = useWizardReportDataContext();

    const [inputValue, setInputValue] = useState('');
    const inputRef = useRef<HTMLDivElement | null>(null);
    const [selectedItem, setSelectedItem] = useState<IReportAvailableColumn | null>(null);

    useEffect(() => {
        setSelectedItem(
            options.find(x =>
                x.columnName === pivotData?.parentColumn?.columnName
            ) ?? null
        );
    }, [options, pivotData]);


    const handleSelectionChange = (e: any, newValue: IReportAvailableColumn | null) => {
        setPivotData((prev) => ({
            ...prev,
            parentColumn: newValue,
            parentGroupByFunction: (
                prev?.parentColumn?.columnDataType === newValue?.columnDataType ?
                    prev?.parentGroupByFunction : null
            )
        }))
    }

    useEffect(() => {
        if (inputRef && inputRef.current) {
            inputRef.current.focus();
        }
    }, [inputRef]);


    // ---
    return (<Autocomplete
        size='small'
        options={options}
        value={selectedItem}
        onChange={handleSelectionChange}
        inputValue={inputValue}
        onInputChange={(e, newInputValue) => setInputValue(newInputValue)}
        getOptionLabel={(option) => (option ? option.columnDescription || option.columnName : '')}
        renderInput={(params) =>
            <TextField
                {...params}
                inputRef={inputRef}
                label='Pivot By'
                placeholder='Select or Search...'
            />}
        renderGroup={(params) => (
            <li key={params.key}>
                <ul style={{ padding: 0 }}>{params.children}</ul>
            </li>
        )}
    />);
}